module.exports = __webpack_public_path__ + "img/Number=13.1f3bfd4e.png";